import React from 'react'
import {useTranslation} from 'i18n'
import {GIFT_SHOP_ROOT_CONTENT_EMPTY_IMAGE_HEIGHT} from 'consts'
import {RoboyuConfused} from 'common/components'
import {useSelector} from 'lib/redux'
import convertUnit from 'lib/unit'
import {GiftShopRootEmpty} from '../../../root'

export default function GiftShopErrorNotFound() {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <GiftShopRootEmpty
      image={
        <RoboyuConfused
          width={convertUnit(GIFT_SHOP_ROOT_CONTENT_EMPTY_IMAGE_HEIGHT)}
          height={convertUnit(GIFT_SHOP_ROOT_CONTENT_EMPTY_IMAGE_HEIGHT)}
          colorTheme={colorTheme.name}
        />
      }
      imageAlt=""
      title={translate('giftShop:pageNotFoundTitle')}
      message={translate('giftShop:pageNotFoundDescription')}
    />
  )
}
